import { render, staticRenderFns } from "./Form_Staff.vue?vue&type=template&id=97618970&scoped=true"
import script from "./Form_Staff.vue?vue&type=script&lang=js"
export * from "./Form_Staff.vue?vue&type=script&lang=js"
import style0 from "./Form_Staff.vue?vue&type=style&index=0&id=97618970&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97618970",
  null
  
)

export default component.exports